import React from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import RentResumenListTabs from './RentResumeListTabs';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const RentResumeListView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title={t('NAVIGATION.PERIOD_INCOME')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar />
          <Box mt={3}>
            <RentResumenListTabs />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default RentResumeListView;
